__turbopack_context__.v({
  "className": "inter_236a8d63-module__Jw5_8a__className",
  "variable": "inter_236a8d63-module__Jw5_8a__variable",
});
